/** Build-time configuration (Vite env). */

const env = import.meta.env as Record<string, string | undefined>;

export const API_URL = (env.VITE_API_URL ?? 'http://localhost:8787').replace(/\/$/, '');
export const WS_URL = API_URL.replace(/^http/, 'ws');

export type AuthMode = 'dev' | 'firebase';
export const AUTH_MODE: AuthMode = env.VITE_AUTH_MODE === 'firebase' ? 'firebase' : 'dev';

/** Drawing in the browser is a development convenience; the product draws only in the native app (spec §2.3). */
export const DEV_DRAW = env.VITE_DEV_DRAW === '1';

export const DEV_LOCATION: { lat: number; lng: number } | null = (() => {
  const raw = env.VITE_DEV_LOCATION;
  if (!raw) return null;
  const [lat, lng] = raw.split(',').map((s) => Number(s.trim()));
  return Number.isFinite(lat) && Number.isFinite(lng) ? { lat, lng } : null;
})();

export const FIREBASE_CONFIG = env.VITE_FIREBASE_API_KEY
  ? {
      apiKey: env.VITE_FIREBASE_API_KEY,
      authDomain: env.VITE_FIREBASE_AUTH_DOMAIN,
      projectId: env.VITE_FIREBASE_PROJECT_ID,
      appId: env.VITE_FIREBASE_APP_ID,
    }
  : null;

/**
 * Replay is built and tested but not offered to people yet. Set this to true to
 * put it back in the top bar and on the home page; `/map?replay=1` reaches it
 * meanwhile, which is how the end-to-end test drives it.
 */
export const REPLAY_ENABLED = false;

export const LOCATION_PURPOSE = 'Draw Earth uses your location so you can paint on the canvas where you are.';
